/*constant variables for search configuration files */
export const SEARCH_CONFIG_UNITS_BY_PERSON = 'fs/res/searchUnitsByPerson.xml';

export const SEARCH_CONFIG_PATENT = 'fs/res/searchPatent.xml';
export const SEARCH_CONFIG_PATENT_HEADLESS = 'fs/res/searchPatentHeadless.xml';

export const SEARCH_CONFIG_PROJECT = 'fs/res/searchProject.xml';
export const SEARCH_CONFIG_MINI_PROJECT = 'fs/res/searchMiniProject.xml';
export const SEARCH_CONFIG_PROJECT_HEADLESS = 'fs/res/searchProjectHeadless.xml';

export const SEARCH_CONFIG_BUDGET_SOURCE = 'fs/res/searchBudgetSource.xml';

export const SEARCH_CONFIG_PUBLICATION = 'fs/res/searchPublication.xml';
export const SEARCH_CONFIG_MINI_PUBLICATION = 'fs/res/searchMiniPublication.xml';
export const SEARCH_CONFIG_PUBLICATION_HEADLESS = 'fs/res/searchPublicationHeadless.xml';

export const SEARCH_CONFIG_JOURNAL = 'fs/res/searchJournal.xml';
export const SEARCH_CONFIG_MINI_JOURNAL = 'fs/res/searchMiniJournal.xml';

export const SEARCH_CONFIG_PUBLISHER = 'fs/res/searchPublisher.xml';

export const SEARCH_CONFIG_EMPLOYMENT = 'cs/psv/searchEmployment.xml';

export const SEARCH_CONFIG_FUNDING_NOTIFICATION = 'fs/res/searchFundingNotification.xml';
export const SEARCH_CONFIG_FUNDING_NOTIFICATION_UNCHECKED = 'fs/res/searchFundingNotificationUnchecked.xml';
